import styled from 'styled-components'

const Breadcrumb = {}

Breadcrumb.Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`

Breadcrumb.Crumb = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`

export default Breadcrumb
